module.exports = __webpack_public_path__ + "img/br.caf2cf2c.svg";